import { useT } from '../../contexts/LocaleContext.jsx';

import '../../styles/partial/LoadingSpinner.css';

/**
 * The shared loading indicator. The spinning glyph is decoration; loading is
 * announced by the visually hidden, localized text in the `status` region
 * (ENG-837), so it is still conveyed when reduced motion stops the spin.
 */
const LoadingSpinner = () => {
  const t = useT();
  return (
    <div className="loading-animation" role="status">
      <div className="spinner" aria-hidden="true">+</div>
      <span className="loading-spinner-text">{t('loading.spinner')}</span>
    </div>
  );
};

export default LoadingSpinner;
